// A user's verified emails by kind: primary, secondaries (up to 3). As the fullstack's
// base-layer/shared/clerk/emailAddresses.js (CLERK.md § Several emails per user).

export const MAX_SECONDARY_EMAILS = 3;

function getIsVerified(address) {
  return address?.verification?.status === "verified";
}

// {primary, secondaries}: address objects ({id, emailAddress, …}); unverified ones
// (an addition not yet confirmed) are left out. primaryId: shown as primary already, while the
// server makes it so (useEmailEdit's promotion)
export function getEmailKinds(user, primaryId = user?.primaryEmailAddressId) {
  const addresses = user?.emailAddresses || [];
  const verified = addresses.filter(getIsVerified);
  const primary = addresses.find((item) => item.id === primaryId) || addresses[0] || null;
  const isSecondary = (item) => item.id !== primary?.id;
  return {primary, secondaries: verified.filter(isSecondary)};
}
